import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * DashboardRouter - Routes users to their role-specific dashboard
 * 
 * This component checks the user's role and redirects them to:
 * - /dashboard/student for STUDENT role
 * - /dashboard/professional for PROFESSIONAL role
 * - /dashboard/educator for EDUCATOR role
 * - /admin/dashboard for ADMIN role
 */
const DashboardRouter = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) {
      switch (user.role) {
        case 'STUDENT':
          navigate('/dashboard/student', { replace: true });
          break;
        case 'PROFESSIONAL':
          navigate('/dashboard/professional', { replace: true });
          break;
        case 'EDUCATOR':
          navigate('/dashboard/educator', { replace: true });
          break;
        case 'ADMIN':
          navigate('/admin/dashboard', { replace: true });
          break;
        default:
          navigate('/dashboard/student', { replace: true });
      }
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return null;
};

export default DashboardRouter;
